import React from "react"
import { View, Text, Image } from "react-native";

import { getImagePath } from "../../services/CommonUtils";
import { reformatLocationString } from "../../services/ReformatUtils";

import { LocationName } from "../../constants/ConstantsMapping";

import AppTheme from "../../../AppTheme";
import AppStyles from "../../../AppStyles";
import TextStyle from "../../../TextStyle";

export const LocationIconView = ({
    locationName, isActive = false,
    width = 20, height = 20
}) => {
    let iconName = 'home_outline_black.svg'
    if (locationName == LocationName.home)
        iconName = isActive ? 'home_blue.svg' : 'home_outline_black.svg'
    else if (locationName == LocationName.work)
        iconName = isActive ? 'work_blue.svg' : 'work_outline_black.svg'
    else if (isActive) {
        iconName = 'other_blue.svg'
        width = 15.6
    } else iconName = 'other_outline_black.svg'

    return <Image source={{
        width: width, height: height,
        uri: getImagePath('/images/icons/location/' + iconName)
    }} />
}

export const AddressInfoView = (props) => {
    return <View style={[AppStyles.flexRowStart]}>
        {LocationIconView({
            locationName: props.location['name'],
            isActive: props.isActive
        })}
        <View style={[{
            width: props.textWidth ?? AppTheme.appWidth - 96,
            marginLeft: props.marginLeft ?? 16
        }]}>
            <Text style={[props.textStyle ?? TextStyle.text16b,
            { color: props.titleColor ?? AppTheme.color.black }]}>
                {props.title ?? props.location['name']}</Text>
            <Text numberOfLines={props.numberOfLines ?? 2}
                style={[TextStyle.text12, {
                    color: props.subTitleColor ?? AppTheme.color.grey.text,
                    marginTop: 4, flexWrap: 'wrap'
                }]}>
                {props.subTitle ? props.subTitle : reformatLocationString(
                    props.location['flat_and_building'],
                    props.location['locality'])}</Text>
        </View>
    </View>
}

